
export const DatiAlbum = {
    ImagesAlbum: [
        {
            id: 23,
            img: require("../assets/img/trivella-23.jpg"),
        }, 
        {
            id: 24,
            img: require("../assets/img/trivella-24.jpg"),
        }, 
        {
            id: 25,
            img: require("../assets/img/trivella-25.jpg"),
        }, 
        {
            id: 26,
            img: require("../assets/img/trivella-26.jpg"),
        }, 
        {
            id: 30,
            img: require("../assets/img/trivella-30.jpg"),
        }, 
        {
            id: 31,
            img: require("../assets/img/trivella-31.jpg"),
        }, 
    ]
}